// @flow
import * as React from 'react';
import { FormattedMessage } from 'react-intl';
import HoverIntent from '@liveauctioneers/react-hoverintent';
import isEqual from 'react-fast-compare';
import Link from '@liveauctioneers/caterwaul-components/lib/Link/Link';
import noop from '../../../utils/noop';
import styles from './MegaNavLink.module.scss';

type Props = {|
    active: boolean,
    closeNav: Function,
    link: string,
    mobile: string,
    msgId: string,
    openNav: Function,
    tabletNavigation: Function,
|};

const MegaNavLink = (props: Props) => {
    const { active, closeNav, link, mobile, msgId, openNav, tabletNavigation } = props;

    const isPhone = mobile && mobile !== 'tablet';
    const isTablet = mobile === 'tablet';
    return (
        <HoverIntent
            interval={50}
            onMouseOut={noop}
            onMouseOver={isTablet ? noop : openNav}
            sensitivity={5}
            timeout={50}
        >
            <div className={`${styles.navLink} ${active && !isPhone ? styles.active : ''}`}>
                <Link onClick={!isTablet ? closeNav : tabletNavigation} primaryWeak route to={isTablet ? '' : link}>
                    <FormattedMessage id={msgId} />
                </Link>
            </div>
        </HoverIntent>
    );
};

export default React.memo<Props>(MegaNavLink, isEqual);
